import { render } from "./AuthRdeHeaders.vue?vue&type=template&id=2a0370aa&scoped=true"
import script from "./AuthRdeHeaders.vue?vue&type=script&lang=js"
export * from "./AuthRdeHeaders.vue?vue&type=script&lang=js"

import "./AuthRdeHeaders.vue?vue&type=style&index=0&id=2a0370aa&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0370aa"]])

export default __exports__